import React from "react";
import { Breadcrumbs, Button, Stack } from "@mui/material";
import { ChevronRight, FolderOutlined, HomeOutlined } from "@mui/icons-material";

export interface ProcessBreadcrumbItem {
  id: number | null;
  name: string;
}

interface ProcessBreadcrumbsProps {
  items: ProcessBreadcrumbItem[];
  onNavigate: (id: number | null) => void;
}

const ProcessBreadcrumbs: React.FC<ProcessBreadcrumbsProps> = ({ items, onNavigate }) => (
  <Breadcrumbs separator={<ChevronRight fontSize="small" />} sx={{ minHeight: 46 }}>
    {items.map((item, index) => (
      <Button
        key={`${item.id ?? "root"}-${index}`}
        size="small"
        variant={index === items.length - 1 ? "contained" : "text"}
        color={index === items.length - 1 ? "primary" : "inherit"}
        onClick={() => onNavigate(item.id)}
        startIcon={item.id === null ? <HomeOutlined /> : <FolderOutlined />}
        sx={{ borderRadius: 2, textTransform: "none" }}
      >
        <Stack component="span" maxWidth={180} overflow="hidden" textOverflow="ellipsis">
          {item.name}
        </Stack>
      </Button>
    ))}
  </Breadcrumbs>
);

export default ProcessBreadcrumbs;
